import { render } from "./adminCAbenefitEx.vue?vue&type=template&id=12457394&scoped=true"
import script from "./adminCAbenefitEx.vue?vue&type=script&lang=js"
export * from "./adminCAbenefitEx.vue?vue&type=script&lang=js"

import "./adminCAbenefitEx.vue?vue&type=style&index=0&id=12457394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12457394"]])

export default __exports__